import reduceReducers from "reduce-reducers";

import { BUSINESS_LABEL } from "constants/actionTypes";

import {
  offlineCrudReducer,
  resetStateOnRoleChangeReducer,
} from "lib/reducers";
import { deserializeBusinessLabel as deserializer } from "lib/serializers/businessLabel";

const businessLabelCrudReducer = offlineCrudReducer(BUSINESS_LABEL, {
  deserializer,
});

const businessLabelReducer = reduceReducers(
  businessLabelCrudReducer,
  resetStateOnRoleChangeReducer,
);

export default businessLabelReducer;
